import { LazyLoadImage } from "react-lazy-load-image-component";
import { IProduct } from "../../model/product";
import ProductSmallTile from "../product-tile/product-small-tile";
import styles from "./similar-products.module.css";
import Link from "next/link";
export default function SimilarProducts({
  products,
}: {
  products: IProduct[];
}) {
  if (!products.length) {
    return <></>;
  }
  return (
    <div className={styles.similarProductWrapper}>
      <h4 className={styles.cstmH4}>Andre produkter du kanskje liker</h4>
      <div className={styles.container}>
        {products?.map((p: IProduct, index: number) => {
          return (
            <Link
              href={`/produkter/${p.brand}/${p.urlName}`}
              onClick={() => {
                window.location.href = `/produkter/${p.brand}/${p.urlName}`;
              }}
              replace={true}
              passHref
              key={`similar_${index}`}
            >
              <div className={styles.card}>
                <LazyLoadImage
                  className={styles.image}
                  src={p.image}
                  alt={p.name}
                />
                <br />
                <div className={styles.title}>{p.name}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
